export const checkedClass = {
  methods: {
    toggleClass(target, className) {
      target.classList.toggle(className)
    },
    addCheckedClass(selector, className) {
      let items = document.querySelectorAll(selector);
      for (let i = 0; i < items.length; i++) {
        items[i].classList.add(className)
      }
    },
    removeCheckedClass(className) {
      let items = document.querySelectorAll(`.${className}`);
      for (let i = 0; i < items.length; i++) {
        items[i].classList.remove(className)
      }
    }
  }
};
